import {OrgMapping} from './orgMapping.model';
import {OrgItem} from './orgItem.model';

export class OrganizationsMapping {
    constructor(
        public edutoneOrganizations: OrgItem[] = <OrgItem[]>[],
        public sourceOrganizations: OrgItem[] = <OrgItem[]>[],
        public targetOrganizations: OrgItem[] = <OrgItem[]>[],
        public mappingList: OrgMapping[] = <OrgMapping[]>[],
        public hasMultipleOrgs: boolean = false,
        public sourceType: string = '',
        public targetType: string = '',
        public validationErrors: string[] = []
    ) { }
}

export const NEW_ORG_IDENTIFIER = '-1';
export const NEW_QWIKLABS_SCHOOL_IDENTIFIER = 'not-deployed';
